import { useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { getSquadView } from '../../data';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Typography } from "@material-ui/core";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

function SquadView(props) {
    const leagueID = props.match.params.leagueID;
    const teamID = props.match.params.teamID;
    const [squadData, setSquadData] = useState(undefined);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const f = async () => {
            const data = await getSquadView(leagueID, teamID);
            setSquadData(data);
            setLoading(false);
        };
        f();
    }, [leagueID, teamID]);

    const headers = squadData !== undefined ?
        Object.keys(squadData[0]['gameWeeks']).filter(k => k.toLowerCase().startsWith('gw')) : [];
    headers.unshift('Team');
    headers.unshift('Player Name');
    return (
        <div style={{ 'display': 'flex', 'justifyContent': 'center', 'flexWrap': 'wrap', 'marginBottom': '50px',
            'maxWidth': '600px', 'marginLeft': 'auto', 'marginRight': 'auto'}}>
            <Link to={`/leagues/${leagueID}/teams/${teamID}`} style={{marginTop: '5px', 'flexGrow': 0}} >
                <ArrowBackIcon />
            </Link>
            <Typography variant="h5" style={{'flexGrow': 1}}>
                Squad view - {teamID}
            </Typography>
            {loading && (
                <div style={{'flexBasis': '100%'}}>
                    <CircularProgress />
                </div>
            )}
            {squadData !== undefined &&
            <TableContainer component={Paper} style={{ alignSelf: 'center', flex: 'auto', 'maxWidth': '600px'}}>
                <Table>
                    <TableBody>
                        <TableRow key={'headers'}>
                            {headers.map(h => <TableCell>{h}</TableCell>)}
                        </TableRow>
                        {squadData.map(p =>
                            <TableRow key={p.name}>
                                <TableCell>{p.name}</TableCell>
                                <TableCell>{p.team}</TableCell>
                                {Object.keys(p['gameWeeks']).map(gw => {
                                    const numMatches = p.gameWeeks[gw];
                                    const color = numMatches === 1 ? 'inhert' :
                                        numMatches < 1 ? 'red' : 'green';
                                    return <TableCell style={{'backgroundColor': color}}>{numMatches}</TableCell>
                                })}
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            }
        </div>
    )
};

export default withRouter(SquadView);